import { useTranslation } from 'react-i18next';

export enum ProcessingPipelineType {
  ANALYZE_ACTUALITY = 'ANALYZE_ACTUALITY',
  BUILD_ACTUALITY_PRE_AGGREGATED_TABLES = 'BUILD_ACTUALITY_PRE_AGGREGATED_TABLES',
  // Add more types as needed
}

export interface ProcessingPipelineTypeDetails {
  id: ProcessingPipelineType | string;
  title: string;
  desc?: string;
}

export function useProcessingPipelineTypeDetails(): ProcessingPipelineTypeDetails[] {
  const { t } = useTranslation('app');
  return [
    {
      id: ProcessingPipelineType.ANALYZE_ACTUALITY,
      title: t`System: Auto-Analyse`,
      desc: t`Analyze warehouse actuality data.`,
    },
    {
      id: ProcessingPipelineType.BUILD_ACTUALITY_PRE_AGGREGATED_TABLES,
      title: t`System: Pre-Aggregate`,
      desc: t`Builds pre-aggregated tables for actuality analysis.`,
    },
    {
      id: 'GENERIC',
      title: t`User: Automation`,
      desc: t`Generic pipeline.`,
    },
    // Add more as needed
  ];
}

// Pure function for lookup
export function getProcessingPipelineTypeDetailById(
  details: ProcessingPipelineTypeDetails[],
  id: string
) {
  return details.find(d => d.id === id);
}
